/**
 * 날짜는 **이 컴퓨터의 시간대(한국)** 기준으로 만든다.
 *
 * `new Date().toISOString()` 은 UTC 라서 한국 시각 0~9시에는 하루 전 날짜가 된다
 * (2026-10-09 새벽에 리스크 평가 이력이 10-08 로 찍혀 발견). 입출금일 기본값처럼
 * 「오늘」이 들어가는 곳은 전부 여기를 쓴다.
 */
const pad = (n: number) => String(n).padStart(2, '0');

/** YYYY-MM-DD */
export function todayLocal(d = new Date()): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** n 달 전 같은 날(YYYY-MM-DD). 그 달에 그날이 없으면 말일 — 8-31 의 6달 전은 2-28(29) */
export function monthsAgo(n: number, d = new Date()): string {
  const first = new Date(d.getFullYear(), d.getMonth() - n, 1);
  const last = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
  return todayLocal(new Date(first.getFullYear(), first.getMonth(), Math.min(d.getDate(), last)));
}

/** YYYY-MM-DD HH:mm */
export function nowLocal(d = new Date()): string {
  return `${todayLocal(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
